/*
 * Copyright (c) 2021. Sanish Manandhar
 * All Rights Reserved
 */

export const SETTINGS_UPSERT_WORKING_HOUR_REQUEST = 'SETTINGS_UPSERT_WORKING_HOUR_REQUEST';
export const SETTINGS_UPSERT_WORKING_HOUR_REQUEST_SUCCESS =
  'SETTINGS_UPSERT_WORKING_HOUR_REQUEST_SUCCESS';
export const SETTINGS_UPSERT_WORKING_HOUR_REQUEST_FAILURE =
  'SETTINGS_UPSERT_WORKING_HOUR_REQUEST_FAILURE';

export const SETTINGS_FETCH_WORKING_HOUR_REQUEST = 'SETTINGS_FETCH_WORKING_HOUR_REQUEST';
export const SETTINGS_FETCH_WORKING_HOUR_REQUEST_SUCCESS =
  'SETTINGS_FETCH_WORKING_HOUR_REQUEST_SUCCESS';
export const SETTINGS_FETCH_WORKING_HOUR_REQUEST_FAILURE =
  'SETTINGS_FETCH_WORKING_HOUR_REQUEST_FAILURE';

export const WORKING_HOUR_CLEAN_REQUEST = 'WORKING_HOUR_CLEAN_REQUEST';
